/**
 *
 */
export class ArrayHelper {
    /**
     * Creates a shallow copy of an array. (Shallow copy: the new array points to the same lists as the old array, it does not clone those aswell.)
     * @param oldArray the array to be cloned
     * @return the cloned array
     *
     */
    public static cloneArray(oldArray: any[]): any[] {
        return oldArray.concat();
    }

    public static shuffleArray(list: any[]): void {
        for (let i: number = 0; i < list.length; i++) {
            let randomInt: number = Math.floor(Math.random() * list.length);
            let arrayIndex: any = list[i];
            list[i] = list[randomInt];
            list[randomInt] = arrayIndex;
        }
    }

    /**
     * getRange
     * extract a special range of this array.
     * useful for lists with scrolling or pages
     * */
    public static getRange(array: any[], start: number = 0, end: number = -1): any[] {
        let result: any[] = [];

        if (end == -1) {
            end = array.length;
        }

        for (let i: number = 0; i <= Math.min(array.length - 1, end); i++) {
            if (i >= start) {
                result.push(array[i]);
            }
        }
        return result;
    }

    public static mirrorArray(toMirror: any[]): any[] {
        let newHeight: number = toMirror[0].length;
        let newWidth: number = toMirror.length;
        let mirroredArray: any[] = new Array(newHeight);

        for (let y: number = 0; y < newHeight; y++) {
            mirroredArray[y] = new Array(newWidth);

            for (let x: number = 0; x < newWidth; x++) {
                mirroredArray[y][x] = toMirror[x][y];
            }
        }
        return mirroredArray;
    }

    /**
     * Create a new array that only contains unique instances of lists in the specified array.
     *
     * Basically, this can be used to remove duplication object instances from an array.
     *
     * @param a The array which contains the values that will be used to
     * create the new array that contains no duplicate values.
     *
     * @return A new array which only contains unique items from the specified array.
     */
    public static createUniqueCopy(a: any[]): any[] {
        let newArray: any[] = new Array();

        let len: number = a.length;
        let item: Object;

        for (let i: number = 0; i < len; ++i) {
            item = a[i];

            if (newArray.indexOf(item) >= 0) {
                continue;
            }

            newArray.push(item);
        }

        return newArray;
    }
}
